/**
 * @desc 查询中台退货单的mrbNo
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.asMaterialRejectBillFacadeImpl.getMrbNoBySpMrbNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/getMrbNosBySpMrbNo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
